import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const MaterialsRoute = lazy(() => import("@/pages/materials.page"));

export const Route = createFileRoute("/materials")({
  component: MaterialsRoute,
});
